import * as React from 'react';
import { useState } from 'react';
import { apiPost } from '../../../services/api';
import AddModal from '../../../components/admin/thirdPartyManagement/update/AddModal';
import LoadingModal from '../../../components/common/LoadingModal';
import ErrorModal from '../../../components/common/ErrorModal';
import DropdownOption from '../../../lib/bootstrap-ui/Dropdown/DropdownOption';
import { getErrorMessage } from '../../../helpers/errors';

interface AddModalContainerProps {
    showModal: boolean;
    selectedOption: DropdownOption;
    onClose(): void;
}

const AddModalContainer: React.FC<AddModalContainerProps> = ({
    showModal,
    selectedOption,
    onClose
}) => {
    const [updatingValues, setUpdatingValues] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string>();

    const handleAddRequested = async (value: string) => {
        setUpdatingValues(true);
        try {
            await apiPost(selectedOption.value, value);
            setUpdatingValues(false);
            onClose();
        } catch (e) {
            setUpdatingValues(false);
            setErrorMessage(getErrorMessage(e));
        }
    };

    const showLoadingModal = showModal && updatingValues;
    const showAddModal = showModal && !updatingValues && !errorMessage;
    const showErrorModal = showModal && !!errorMessage;

    return (
        <>
            <LoadingModal
                showModal={showLoadingModal}
                loadingText="adding..."
            />
            <AddModal
                showModal={showAddModal}
                selectedOption={selectedOption}
                onAddRequested={handleAddRequested}
                onClose={onClose}
            />
            <ErrorModal
                showModal={showErrorModal}
                header="Error"
                errorText={errorMessage}
                onClose={onClose}
            />
        </>
    );
};

export default AddModalContainer;
